export * from './highlightJs.module';
export * from './highlightJs.token';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-highlight-js/dist/esm/src/index.js
// module id = ./node_modules/angular-highlight-js/dist/esm/src/index.js
// module chunks = common